import React, { useRef, useState, useCallback } from "react";
import ReactPlayer from "react-player";
import "./GenericVideoPlayer.scss";

function GenericVideoPlayer({ url, autoPlay = false }) {
  const playerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(autoPlay);
  const [showHoverControls, setShowHoverControls] = useState(false);

  const handlePlayPause = () => {
    setIsPlaying((prev) => !prev);
  };

  return (
    <div
      className="gvp-container"
      onMouseEnter={() => setShowHoverControls(true)}
      onMouseLeave={() => setShowHoverControls(false)}
    >
      <div className="gvp-player-wrapper">
        <ReactPlayer
          ref={playerRef}
          url={url}
          playing={isPlaying}
          width="100%"
          height="100%"
          controls={false}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          config={{
            youtube: {
              playerVars: {
                controls: 0,
                modestbranding: 1,
                rel: 0,
                disablekb: 1,
              },
            },
          }}
        />

        {/* ---------- BIG CENTER PLAY BUTTON (when video is not playing) ---------- */}
        {!isPlaying && (
          <div className="gvp-center-play">
            <button
              type="button"
              className="gvp-big-play-button"
              onClick={handlePlayPause}
            >
              ▶
            </button>
          </div>
        )}

        {/* ---------- SMALL PLAY/PAUSE ON HOVER ---------- */}
        {showHoverControls && (
          <button
            type="button"
            className="gvp-hover-play-button"
            onClick={handlePlayPause}
          >
            {isPlaying ? "❚❚" : "▶"}
          </button>
        )}
      </div>
    </div>
  );
}

export default GenericVideoPlayer;
